import IframeActivity from "./IframeActivity";

export default function BeforeTheyKnew2() {
    return (
        <IframeActivity
            src="/activities/before-they-knew-2/index.html"
            title="Before They Knew (Again)"
        />
    );
}